export const SMS_CONVERSATION_ENDPOINT = {
  getConversations: {
    url: '/v1/sms-communication/conversations',
    method: 'GET',
  },
  getMessages: (id) => ({
    url: `/v1/sms-communication/messages/${id}`,
    method: 'GET',
  }),
  reply: {
    url: '/v1/sms-communication/reply',
    method: 'POST',
  },
  markRead: (id) => ({
    url: `/v1/sms-communication/mark-read/${id}`,
    method: 'PATCH',
  }),
};
